import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { SxProps, Theme } from "@mui/material";
import { CSSProperties, HTMLAttributes } from "react";
import { Text } from "../../../core-ui/components/Text/Text";
import { TextColor, TextStyleVariant } from "../Text/TextUtils";
import {
  ChipButton,
  ChipCloseIcon,
  ChipContainer,
  ChipContainerOutlined,
} from "./Chip.styles";

export interface ChipProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "onClick"> {
  text: string;
  upperCase?: boolean;
  onDelete?: () => void;
  style?: CSSProperties;
  variant?: ChipVariant;
  loading?: boolean;
  overrideSx?: SxProps<Theme>;
}

export enum ChipVariant {
  OUTLINED = "outlined",
  DEFAULT = "default",
}

const ChipVariantMap: Record<ChipVariant, typeof ChipContainer> = {
  [ChipVariant.OUTLINED]: ChipContainerOutlined,
  [ChipVariant.DEFAULT]: ChipContainer,
};

export const Chip = ({
  text,
  upperCase = false,
  onDelete,
  style,
  variant = ChipVariant.DEFAULT,
  children,
  loading,
  overrideSx,
  ...props
}: ChipProps) => {
  const ChipContainerWithVariant = ChipVariantMap[variant];
  return (
    <ChipContainerWithVariant
      style={style}
      $onDelete={Boolean(onDelete)}
      $loading={loading}
      sx={overrideSx}
      {...props}
    >
      <Text
        color={loading ? TextColor.TERTIARY : TextColor.SECONDARY}
        style={{ lineHeight: "0.875rem" }}
        variant={TextStyleVariant.P2}
      >
        {upperCase ? text.toUpperCase() : text}
      </Text>
      {children}
      {onDelete && (
        <ChipButton style={style} onClick={onDelete} disabled={loading}>
          <ChipCloseIcon icon={faXmark} onClick={onDelete} />
        </ChipButton>
      )}
    </ChipContainerWithVariant>
  );
};
